"use strict";
function idx(...ids) {
  return ids.filter((id) => Boolean(id)).join(" ") || void 0;
}
export {
  idx
};
